import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  chatContainer: {
    flex: 1,
    maxHeight: 300,
    maxWidth: 500,
    // padding: theme.spacing(1),
    padding: '0px',
    overflowY: 'scroll',
    ...theme.scrollbarStyles,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  notificationTicket: {
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.gray_50.main,
    borderRadius: '8px',
    cursor: 'pointer',
    // '&:hover': {
    //   backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.blue_50.main
    // }
  },
  popoverPaper: {
    width: '100%',
    maxWidth: 350,
    // marginLeft: theme.spacing(2),
    // marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 270
    }
  },
  noShadow: {
    boxShadow: 'none !important'
  }
}))
